import { render } from "./MemberTierDuration.vue?vue&type=template&id=461e36b3"
import script from "./MemberTierDuration.vue?vue&type=script&lang=js"
export * from "./MemberTierDuration.vue?vue&type=script&lang=js"

import "./MemberTierDuration.vue?vue&type=style&index=0&id=461e36b3&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__